import { TableColumnType } from 'src/types/table';

export const REQUIRED_MESSAGES_ON_BOX_GRID_COLUMNS = ['ID', 'MESSAGE', 'COUNTRY'];

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        defaultShow: true,
        type: 'id',
    },
    {
        key: 'MESSAGE',
        label: 'message',
        defaultShow: true,
    },
    {
        key: 'COUNTRY',
        label: 'country',
        defaultShow: true,
        type: 'select',
        selectOption: 'countryOptionsCodes',
    },
];
